import React, { useEffect, useState } from 'react';

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export const CustomSelect = ({ disabled, name, labelId, id, label, value, options, onFocus, onChange, onBlur, error}) => {
    const [localValue, setLocalValue] = useState(value ?? ''); 
    
    useEffect(() => {
        setLocalValue(value ?? ''), [value]
   //     console.log(`customselect`,localValue)
    });       
    const handleFocus = () => {
        if (onFocus) {
            onFocus();
        }
    };
    const handleChange = (e) => {
        const value = e.target.value;
        setLocalValue(value);
        if (onChange) {
            onChange(e);
        }
   //     console.log (`change`, e)
    };
    const handleBlur = (e) => {
        if (onBlur) {
            onBlur(e.target.value);
        }
    };
    return (
        <Select
            disabled={disabled}
            name={name}
            labelId={labelId}
            id={id}
            label={label}
            value={localValue}      
            onFocus={handleFocus}
            onChange={handleChange} 
            onBlur={handleBlur}
            error={error}
        >
            {options?.map(option => {
                return (
                    <MenuItem key={option.value} value={option.value} disabled={option?.disabled}>
                        {option.label ?? option.value}
                    </MenuItem>
                );
            })}
        </Select>
    );
};

export default CustomSelect;